function Login() {
  window.location.replace(process.env.REACT_APP_COGNITO_LOGIN_URL);
}

export default Login;
